import React from "react";
import { strings } from "../../../../localisation";
import { EmptyPreviewDiv, PreviewIframe } from "./PreviewPanel.styles";

export interface IPreviewPanelProps {
    Body: string;
}

export const PreviewPanel = ({ Body }: IPreviewPanelProps) => {
    const iframeRef = React.createRef<HTMLIFrameElement>();

    React.useEffect(() => {
        if (iframeRef?.current?.contentWindow) {
            iframeRef.current.contentWindow.document.open();
            iframeRef.current.contentWindow.document.write(Body);
            iframeRef.current.contentWindow.document.close();
        }
    }, [iframeRef, Body]);

    if (!Body.length) {
        return (
            <EmptyPreviewDiv>
                {strings.Message_Preview_EmptyPreview}
            </EmptyPreviewDiv>
        );
    }

    return (
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox
        // Allow for links and buttons etc but not <script></script>
        // Well this is at least the intention
        <PreviewIframe ref={iframeRef} sandbox="allow-same-origin allow-popups" />
    );
};
